import React from "react";

import { EMPTY_STRING } from "../../../../constants";
import SurveyCompleteIcon from "../../../../assets/icons/auth-form/survey-complete.png";
import RoundedButton from "../../../../shared/components/buttons/RoundedButton";

const ThankYouScreen = ({ isAgent, closeModal = () => {} }) => {
  return (
    <>
      <div className="mt-5 mb-3">
        <img
          src={SurveyCompleteIcon}
          alt={EMPTY_STRING}
          className="d-flex m-auto"
        />
      </div>
      <div className="text-center thank-you-text" >
        Thank you for registering with Bayview Shores.
      </div>
      {isAgent ? null : (
        <div className="thank-you-wrapper">
          <div className="text-center thank-you-text">
            Please check your email to complete the verification.
          </div>

          <RoundedButton
            cotainerClass="w-100 d-flex justify-content-center"
            className="px-5 py-2 my-4"
            onClick={() => closeModal()}
          >
            Login
          </RoundedButton>
        </div>
      )}
    </>
  );
};

export default ThankYouScreen;
